import { render, staticRenderFns } from "./ClearButton.vue?vue&type=template&id=264f1b6e&scoped=true&"
import script from "./ClearButton.ts?vue&type=script&lang=ts&"
export * from "./ClearButton.ts?vue&type=script&lang=ts&"
import style0 from "./ClearButton.css?vue&type=style&index=0&id=264f1b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f1b6e",
  null
  
)

export default component.exports